import { camelCase, mapKeys, snakeCase } from 'lodash/fp';
import { USER_CONTINENT, USER_COUNTRY } from '@whitelabel/helpers/constants';
import { isOnServer } from '@whitelabel/helpers/utils';
import api, { API_HOST } from './api';

export async function storeUserGeoIpInfo(): Promise<void> {
  try {
    const { countryCode, continentCode } = await api.get(`${API_HOST}/geoip/`, false);
    if (countryCode) {
      sessionStorage.setItem(USER_COUNTRY, countryCode);
    }
    if (continentCode) {
      sessionStorage.setItem(USER_CONTINENT, continentCode);
    }
  } catch {
    // ignore geoip error
  }
}

export const getLoggedInCustomerID = () => {
  if (isOnServer) return '';
  const key = `CognitoIdentityServiceProvider.${process.env.NEXT_PUBLIC_COGNITO_APP_CLIENT_ID}.LastAuthUser`;
  return localStorage.getItem(key) as string;
};

/**
 * Remove the email to be empty string if that email is our system generated
 */
export const filterGeneratedEmail = (email: string | undefined) => (email?.includes('@xcover.com') ? '' : email);

//  Convert a string to snake case with few custom convertion logic
const customSnakeKeys = (key: any) => {
  const matches = {
    birthDate: 'date_of_birth',
    postcode: 'postal_code',
    address1: 'address1',
    address2: 'address2',
    region: 'state_province',
  };
  return matches[key as keyof typeof matches] || snakeCase(key);
};

const customCamelKeys = (key: any) => {
  const matches = {
    date_of_birth: 'birthDate',
    postal_code: 'postcode',
    state_province: 'region',
  };
  return matches[key as keyof typeof matches] || camelCase(key);
};

//  Returns an object with field name keys similar to response. Eg: first name transform to first_name (not firstName)
export function updateClaimantKeys<T>(claimant: any, convertToCamelCase = false) {
  return mapKeys(convertToCamelCase ? customCamelKeys : customSnakeKeys)(claimant) as unknown as T;
}

export function sliceArrayIntoChunks<T>(arr: T[], chunkSize: number) {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}

export function getLocalStorageValueOrNull<T>(localStorageKey: string) {
  return localStorage.getItem(localStorageKey)
    ? (JSON.parse(localStorage.getItem(localStorageKey) as string) as T)
    : null;
}
